import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { ShDragDataDirective } from '../../elements/directives/drag-data/drag-data.directive';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'sh-detail-layout',
    templateUrl: './detail-layout.component.html',
    styleUrl: './detail-layout.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShDragDataDirective, NgTemplateOutlet]
})
export class DetailLayoutComponent {
    @Input() dragData: string | null | undefined;

    @ContentChild('aside') asideContent: TemplateRef<any>;
    @ContentChild('main') mainContent: TemplateRef<any>;
}
